import { Modal, Text, ButtonGroup, Button } from '@nike/eds';

type RankingListPreviewProps = {
  item: RankingList | null;
  open: boolean;
  closeDeleteModal: () => void;
  submitDelete: () => void;
};
export default function RankingListDelete(props: RankingListPreviewProps) {
  const { item, open, closeDeleteModal, submitDelete } = props;
  const title = props?.item?.title;
  return (
    <>
      <Modal
        headerSlot={'Delete Rank'}
        isOpen={props.open}
        onDismiss={() => {
          closeDeleteModal();
        }}
      >
        <Text>Are you sure you want to delete this Rank?</Text>
        <Text className='tw-pt-2 tw-font-bold'>{title}</Text>
        <ButtonGroup className='tw-justify-end'>
          <Button
            disableRipple
            onClick={() => {
              submitDelete();
            }}
            size='medium'
          >
            Confirm
          </Button>
          <Button
            disableRipple
            onClick={() => {
              closeDeleteModal();
            }}
            size='medium'
            variant='secondary'
          >
            Cancel
          </Button>
        </ButtonGroup>
      </Modal>
    </>
  );
}
